export default (theme) => ({
  messageBox: {
    padding: "1rem 1rem",
    marginBottom: "1rem",
    border: "1px solid transparent",
    fontFamily: "realist, sans-serif",
    color: theme.palette.type === "dark" ? "white !important" : undefined,
  },
});
